import { render, staticRenderFns } from "./u-tabs-filled.vue?vue&type=template&id=e99aa922&scoped=true"
import script from "./u-tabs-filled.vue?vue&type=script&lang=js"
export * from "./u-tabs-filled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99aa922",
  null
  
)

export default component.exports